<template>
  <div class="page">
    <pc-header :isTransparent.sync="isTransparent"></pc-header>

    <div class="home">
      <img src="~@/assets/pc/home.jpg" />
      <div class="content">
        <div @click="$router.push({ path:'/pc-project' })">
          <img alt src="~@/assets/pc/introduce-01.png" />
        </div>
        <div @click="$router.push({ path:'/pc-product' })">
          <img alt src="~@/assets/pc/introduce-02.png" />
        </div>
        <div @click="$router.push({ path:'/pc-honor' })">
          <img alt src="~@/assets/pc/introduce-03.png" />
        </div>
      </div>
    </div>
    <div class="icp">
      <div @click="onIcpJump">粤ICP备15070469号</div>
      <div>公司名称：广东东阳光大健康销售有限公司</div>
      <div>联系地址：乳源县乳城镇侯公渡东阳光工业园药厂研发中心102室</div>
      <div>联系电话：0769-8861-5888</div>
    </div>
  </div>
</template>

<script>
import pcHeader from "@/components/pcHeader"
export default {
  metaInfo: {
    title: "东阳光冬虫夏草官网",
    meta: [
      {
        name: "keywords",
        content: "关键字"
      },
      {
        name: "description",
        content: "网页描述"
      }
    ]
  },
  components: {
    "pc-header": pcHeader
  },
  data () {
    return {
      isTransparent: false // 是否透明
    }
  },
  methods: {
    /**
     * 事件绑定 - 点击备案号跳转
     *
     * @return {void}
     */
    onIcpJump() {
      window.location.href = "https://beian.miit.gov.cn"
    }
  }
}
</script>

<style scoped lang="stylus">
img {
  width: 100%;
  height: 100%;
}

body {
  overflow-y: hidden;
}

.home {
  margin-top: -80px;

  .content {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: -177px;

    div {
      height: 306px;
      width: 370px;
    }
  }
}

.icp {
  margin-bottom: 5px;
  text-align: center;
  width: 100%;
  color: #777;
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// pcHome.vue